
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cuenta/nueva",
      function () {
        return require("private-next-pages/cuenta/nueva/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cuenta/nueva"])
      });
    }
  